var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.pdfLoading),expression:"pdfLoading"}],attrs:{"id":"pdfs"}},_vm._l((_vm.pagesArr),function(obj,index){return _c('div',{key:index,staticClass:"pdf-pages"},[_c('canvas',{attrs:{"id":_vm.compId + 'the-canvas' + index}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }